export const specialEffects = {
  fxmaster: {
    label: "FXMaster",
    effects: [
      {
        label: "Smoke Bomb",
        file: "modules/fxmaster/assets/special-effects/fxmaster/smoke-bomb.webm",
        scale: {
          x: 1.0,
          y: 1.0,
        },
        angle: 0,
        anchor: {
          x: 0.5,
          y: 0.5,
        },
        speed: 0,
        author: "U~man",
      },
      {
        label: "Fireball",
        file: "modules/fxmaster/assets/special-effects/fxmaster/fireball.webm",
        scale: {
          x: 1.0,
          y: 1.0,
        },
        angle: 0,
        anchor: {
          x: 0.5,
          y: 0.5,
        },
        author: "U~man",
      },
      {
        label: "Blood Splatter",
        file: "modules/fxmaster/assets/special-effects/fxmaster/blood.webm",
        scale: {
          x: 0.7,
          y: 0.7,
        },
        angle: 0,
        anchor: {
          x: 0.5,
          y: 0.5,
        },
        author: "U~man",
      },
      {
        label: "Red Fire Cone",
        file: "modules/fxmaster/assets/special-effects/jinker/dragonBornGold-RedFire15Cone.webm",
        scale: {
          x: 1.0,
          y: 1.0,
        },
        angle: 0,
        anchor: {
          x: 0,
          y: 0.5,
        },
        author: "Jinker",
      },
      {
        label: "Acid Line",
        file: "modules/fxmaster/assets/special-effects/jinker/dragonBornBlack-CopperAcid30x5Line.webm",
        scale: {
          x: 1.0,
          y: 1.0,
        },
        angle: 0,
        anchor: {
          x: 0,
          y: 0.5,
        },
        author: "Jinker",
      },
      {
        label: "Witch Bolt",
        file: "modules/fxmaster/assets/special-effects/jb2a/Witch_Bolt_Blue_600x200.webm",
        scale: {
          x: 0.7,
          y: 0.7,
        },
        angle: 0,
        anchor: {
          x: 0,
          y: 0.5,
        },
        author: "JB2A",
      },
    ],
  },
};
